/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/9/29 9:35 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */
import OperateFactory from '@/plugins/factory/OperateFactory';

export default class ModifyFactory extends OperateFactory {
}
